// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 790px) {
  .section {
    flex-direction: column;
    padding-top: 50px;
  }
  .product h1 {
    font-size: 32px;
  }
  .product p {
    font-size: 18px;
    margin-top: 20px;
  }
  .phone16pro {
    width: 80%;
    margin-top: 40px;
  }
  .about {
    flex-direction: column;
  }
  .about h2 {
    font-size: 24px;
  }
  .feature_card {
    width: 100%;
    margin-top: 20px;
  }
  .about h2 span {
    font-size: 24px;
  }
  .about_text {
    width: 100%;
  }
  .features_grid {
    flex-direction: column;
  }
  .bonus h1 {
    font-size: 32px;
  }
  .Clippathgroup {
    position: absolute;
    right: -5%;
    z-index: 999;
    top: 200px;
  }
  .none {
    display: flex !important;
    gap: 10px;
  }
  .none img {
    width: 100%;
  }
  .qr {
    display: none;
  }
  .logo_footer {
    width: 70%;
  }
  .Advantages {
    flex-direction: column;
    text-align: center;
    margin-bottom: 30px;
  }
  #footer {
    padding: 40px;
  }
  .instagram {
    flex-direction: column;
  }
  .applecation {
    padding: 24px;
    flex-direction: column;
    justify-content: start !important;
  }
  .pro {
    width: 100%;
  }
  .funk p {
    font-size: 16px;
    font-weight: 400;
  }
  .phones {
    margin-top: 70px;
  }
  .funk h1 {
    width: 100%;
    font-size: 24px;
    font-weight: 700;
  }
  .funk {
    flex-direction: column;
  }
  .two_phone {
    width: 100%;
    z-index: 199;
    position: sticky;
    left: 28%;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -26px auto;
    object-fit: cover;
    object-position: center;
  }
  .bonus {
    width: 100%;
  }
  .food-image img {
    width: 100%;
  }
  .red_food {
    left: -71%;
    top: -28%;
  }
  .red_foods {
    left: 70%;
    top: 14%;
  }
  .koled {
    width: 100%;
    padding: 20px;
    padding-bottom: 40px;
    margin: 0 auto;
  }
  .about_app_container {
    width: 100%;
    flex-direction: column;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
  }
  .about_image img {
    margin-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/media.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,cAAc;EAChB;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@media (max-width: 790px) {\n  .section {\n    flex-direction: column;\n    padding-top: 50px;\n  }\n  .product h1 {\n    font-size: 32px;\n  }\n  .product p {\n    font-size: 18px;\n    margin-top: 20px;\n  }\n  .phone16pro {\n    width: 80%;\n    margin-top: 40px;\n  }\n  .about {\n    flex-direction: column;\n  }\n  .about h2 {\n    font-size: 24px;\n  }\n  .feature_card {\n    width: 100%;\n    margin-top: 20px;\n  }\n  .about h2 span {\n    font-size: 24px;\n  }\n  .about_text {\n    width: 100%;\n  }\n  .features_grid {\n    flex-direction: column;\n  }\n  .bonus h1 {\n    font-size: 32px;\n  }\n  .Clippathgroup {\n    position: absolute;\n    right: -5%;\n    z-index: 999;\n    top: 200px;\n  }\n  .none {\n    display: flex !important;\n    gap: 10px;\n  }\n  .none img {\n    width: 100%;\n  }\n  .qr {\n    display: none;\n  }\n  .logo_footer {\n    width: 70%;\n  }\n  .Advantages {\n    flex-direction: column;\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  #footer {\n    padding: 40px;\n  }\n  .instagram {\n    flex-direction: column;\n  }\n  .applecation {\n    padding: 24px;\n    flex-direction: column;\n    justify-content: start !important;\n  }\n  .pro {\n    width: 100%;\n  }\n  .funk p {\n    font-size: 16px;\n    font-weight: 400;\n  }\n  .phones {\n    margin-top: 70px;\n  }\n  .funk h1 {\n    width: 100%;\n    font-size: 24px;\n    font-weight: 700;\n  }\n  .funk {\n    flex-direction: column;\n  }\n  .two_phone {\n    width: 100%;\n    z-index: 199;\n    position: sticky;\n    left: 28%;\n    z-index: 9;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: -26px auto;\n    object-fit: cover;\n    object-position: center;\n  }\n  .bonus {\n    width: 100%;\n  }\n  .food-image img {\n    width: 100%;\n  }\n  .red_food {\n    left: -71%;\n    top: -28%;\n  }\n  .red_foods {\n    left: 70%;\n    top: 14%;\n  }\n  .koled {\n    width: 100%;\n    padding: 20px;\n    padding-bottom: 40px;\n    margin: 0 auto;\n  }\n  .about_app_container {\n    width: 100%;\n    flex-direction: column;\n    padding-top: 24px;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n  .about_image img {\n    margin-top: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
